/* eslint-disable max-len */
import axios, { AxiosResponse } from "axios";
import {
  IAgent,
  ICreateAgent,
  IGetAgents,
  IUpdateAgent,
} from "../models/agent.model";

export const getAgents = async (payload: IGetAgents) => {
  const params: any = {
    limit: payload.limit,
    page: payload.page,
    keyword: payload.keyword,
    sort: payload.sort,
    direction: payload.direction || "",
  };

  const res = await axios.get("/view_agents", {
    params,
  });
  return res;
};

export const getAgentById = async (id: string) => {
  const res = await axios.get("/view_agent_details", {
    params: {
      agent_id: id,
    },
  });
  return res;
};

export const getStatsAgents = async () => {
  const res = await axios.get("/call_stats_details");
  return res;
};

export const deleteAgent = async (id: string) => {
  const res = await axios.delete("/delete_agent/" + id);
  return res;
};

export const createAgent = async (payload: ICreateAgent) => {
  const res = await axios.post("/create_agent", {
    ...payload,
    // keep backward-compat defaults if BE doesn't supply them
    model_framework: payload.model_framework ?? "STS",
    LLM: payload.LLM ?? "GPT-4o-mini-realtime-preview-2024-12-17",
    language: payload.language ?? "Multi-language",
  });
  return res;
};

export const updateAgent = async (id: string, payload: IUpdateAgent) => {
  const res = await axios.patch("/update_agent/" + id, payload);
  return res;
};

export const getTools = async () => {
  const res = await axios.get("/tools");
  return res;
};

export const createBaseKnowledge = async (files: File[]) => {
  const formData = new FormData();
  (files || []).forEach((file) => {
    // Append multiple files under the same key 'files'
    formData.append("file", file);
  });

  const res = await axios.post("/create_base_knowledge", formData);
  return res;
};

export const getBaseKnowledge = async () => {
  const res = await axios.get("/base_knowledge");
  return res;
};